var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownOpenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9147 4.38433C3.71652 4.67856 3.28349 4.67856 3.0853 4.38433L0.993849 1.27933C0.770146 0.947217 1.00812 0.5 1.40855 0.5L5.59145 0.5C5.99188 0.5 6.22985 0.947217 6.00615 1.27933L3.9147 4.38433Z",
    fill: "#09414E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownOpenArrow);
export default __webpack_public_path__ + "static/media/dropdown-open-arrow.b952f5ce0efa2ae69aaa6d0660d15502.svg";
export { ForwardRef as ReactComponent };